import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "./components/Button";
import Logo from "./components/Logo";
import Spacers from "./components/Spacers";
import axios from "axios";

import aboutAvatar from "./images/HeadshotCillian.png";
import aboutAvatar2 from "./images/HeadshotCharles.png";
import ebene2 from "./landing/ebene-2.svg";
import icon2 from "./landing/icon-2.svg";
import icon3 from "./landing/icon-3.svg";
import icon from "./landing/icon.svg";
import image2 from "./landing/image2.png";
import image1 from "./landing/image1.png";
import leftArrow from "./landing/left-arrow.svg";
import rightArrow from "./landing/right-arrow.svg";
import heroCircleLeft from "./images/hero_circle_left.png";
import heroCircleRight from "./images/hero_circle_right.png";
import logoWhite from "./images/logo_white.png";

import logger from './utils/logger';

import "./styles/landing_page.scss";

// Video Modal Component
const VideoModal = ({ isOpen, videoId, onClose }) => {
  useEffect(() => {
    // Disable body scroll when modal is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    // Cleanup function
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;
  
  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-content" onClick={e => e.stopPropagation()}>
        <button className="video-modal-close" onClick={onClose}>×</button>
        <div className="video-container">
          <iframe 
            width="100%" 
            height="100%" 
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export const Desktop = () => {
  const testimonials = [
    { quote: "\"My students loved it!\"", person: "— SARAH, TEACHER" },
    { quote: "\"It's such a great resource, I'm actually so shocked.\"", person: "— LIAM, STUDENT" },
    { quote: "\"Oh my god! This is my dream come true!\"", person: "— ANON., TEACHER" },
    { quote: "\"Extremely useful.\"", person: "— EVE, STUDENT" },
    { quote: "\"This is a total game changer! Thank you so much!\"", person: "— NORA, TEACHER" },
    { quote: "\"I think this could be revolutionary.\"", person: "— MARY, TEACHER" },
    {quote: "\"An amazing resource, well done!\"", person: "— STEPHEN, STUDENT" },
    { quote: "\"I love the idea of everything in one place for the students. The feedback is very good. It is a very efficient system, a huge asset.\"", person: "— PAUL, TEACHER" },
    { quote: "\"A brilliant tool!\"", person: "— MARION, TEACHER" }
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [videoModal, setVideoModal] = useState({ isOpen: false, videoId: null });
  const [isPaused, setIsPaused] = useState(false);
  const [email, setEmail] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState({
    message: "",
    isError: false,
    isSubmitting: false
  });

  const featuresRef = useRef(null);
  const navigate = useNavigate();

  // Add this useEffect at the beginning of your component
  useEffect(() => {
    // Function to detect mobile devices
    const isMobileDevice = () => {
      return (
        typeof window.orientation !== 'undefined' ||
        navigator.userAgent.indexOf('IEMobile') !== -1 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
        window.innerWidth <= 768
      );
    };

    // If it's a mobile device, redirect to login page
    // if (isMobileDevice()) {
    //   navigate('/login');
    // }
  }, [navigate]);

  // Auto-rotate testimonials with animation
  useEffect(() => {
    let rotationTimer;
    
    if (!isPaused) {
      rotationTimer = setInterval(() => {
        // Start fade transition
        setIsTransitioning(true);
        
        // Wait for fade out, then change testimonial
        setTimeout(() => {
          setActiveIndex((prev) => (prev + 1) % testimonials.length);
          // End transition after content changes
          setTimeout(() => {
            setIsTransitioning(false);
          }, 50);
        }, 400);
      }, 3500);
    }
    
    return () => {
      clearInterval(rotationTimer);
    };
  }, [isPaused, testimonials.length]);

  const goLeft = () => {
    // Pause auto-rotation temporarily when user manually navigates
    setIsPaused(true);
    setActiveIndex((prev) => prev === 0 ? testimonials.length - 1 : prev - 1);
    
    // Resume auto-rotation after 7 seconds (2 full cycles)
    setTimeout(() => setIsPaused(false), 7000);
  };

  const goRight = () => {
    // Pause auto-rotation temporarily when user manually navigates
    setIsPaused(true);
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
    
    // Resume auto-rotation after 7 seconds (2 full cycles)
    setTimeout(() => setIsPaused(false), 7000);
  };

  const openVideo = (videoId) => {
    setVideoModal({ isOpen: true, videoId });
  };

  const closeVideo = () => {
    setVideoModal({ isOpen: false, videoId: null });
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!email || !email.includes('@') || !email.includes('.')) {
      setSubscriptionStatus({
        message: "Please enter a valid email address",
        isError: true,
        isSubmitting: false
      });
      return;
    }
    
    setSubscriptionStatus({
      message: "",
      isError: false,
      isSubmitting: true
    });
    
    try {
      // Get the base URL
      const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
      logger.info("Using API base URL:", API_BASE_URL);
      
      // For Heroku deployment, use URL without /api prefix, otherwise use /api
      const apiUrl = API_BASE_URL.includes("herokuapp.com") 
        ? `${API_BASE_URL}/join-mailing-list`
        : `${API_BASE_URL}/api/join-mailing-list`;
        
      logger.info("Submitting to:", apiUrl);
      
      const response = await axios.post(apiUrl, {
        email: email,
        source: "uk_landing_page"
      });
      
      setSubscriptionStatus({
        message: response.data.message || "Thank you for subscribing!",
        isError: false,
        isSubmitting: false
      });
      
      // Clear the form
      setEmail("");
      
      // Clear the success message after 5 seconds
      setTimeout(() => {
        setSubscriptionStatus({
          message: "",
          isError: false,
          isSubmitting: false
        });
      }, 5000);
      
    } catch (error) {
      logger.error("Subscription error:", error);
      setSubscriptionStatus({
        message: error.response?.data?.error || "Something went wrong. Please try again.",
        isError: true,
        isSubmitting: false
      });
    }
  };

  const scrollToFeatures = () => {
    featuresRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="desktop">
      {/* Video Modal */}
      <VideoModal 
        isOpen={videoModal.isOpen} 
        videoId={videoModal.videoId} 
        onClose={closeVideo} 
      />

      {/* 1) NAVBAR AT THE TOP */}
      <div className="navbar">
        <div className="navbar-wrapper">
          <div className="navbar-brand">
            <Logo className="logo-2" />
          </div>
          <div className="navbar-links">
            <Link to="/uk/about" className="text-wrapper-18">About Pulc</Link>
            <Link to="/uk/faq" className="text-wrapper-18">FAQ</Link>
            <Link to="/login">
              <Button variant="secondary">Login</Button>
            </Link>
            <Link to="/register">
              <Button variant="primary">Sign Up</Button>
            </Link>
          </div>
        </div>
      </div>

      {/* 2) HERO SECTION WITH HEADLINE & BUTTONS */}
      <div className="hero-section">
        {/* Decorative shapes (circles) */}
        <div className="hero-shapes">
          <div className="big-circle"></div>
          <img 
            src={heroCircleLeft} 
            alt="Decorative circle" 
            className="icon-circle-left" 
          />
          <img 
            src={heroCircleRight} 
            alt="Decorative circle" 
            className="icon-circle-right" 
          />
        </div>

        <div className="hero-content">
          <h1>Your AI Exam Coach & Corrector</h1>
          <p>Free exam-focused feedback from the only AI system tailored specifically for GCSE exams.</p>
          <div className="hero-buttons">
            <Button 
              variant="secondary" 
              onClick={scrollToFeatures}
            >
              See how Pulc can help you
            </Button>
            <Link to="/register">
              <Button variant="primary">Sign Up</Button>
            </Link>
          </div>
        </div>
      </div>

      {/* 3) THE "SECTION INTRO" (optional text below hero) */}
      <Spacers size="sixty-four" />
      <div className="section-intro">
        <div className="intro-wrapper">
          <div className="intro-content">
            {/* Add larger logo here */}
            <div className="large-logo-container">
              <Logo className="logo-large" />
            </div>
            
            {/* If you still want an extra paragraph: */}
            <p className="text-wrapper">
            Pulc trains you to write perfect essays. It grades your work, showing you exactly what 
            a GCSE examiner wants. 
            Then Pulc helps you revise it to make it better and better.
            <br />
            Our unique hybrid AI prevents hallucinations, providing 
            reliable and trustworthy feedback. 
            </p>
          </div>
        </div>
      </div>

      <Spacers size="one-hundred-and-twenty-eight" />

      {/* 4) THE FEATURES (STUDENTS / TEACHERS) */}
      <div className="div-wrapper" ref={featuresRef}>
        <div className="features-grid">
          <div className="features-card">
            <img className="image" alt="Image" src={image2} />
            <Spacers size="thirty-two" />
            <div className="div">For Students</div>
            <Spacers size="sixteen" />
            <div className="features-list">
              <div className="text-wrapper-2">Instant &amp; Detailed Feedback on Your Work</div>
              <div className="text-wrapper-2">Trained for GCSE exams.</div>
              <div className="text-wrapper-2">Available for English, Maths, French, Spanish and German </div>
            </div>
            <Spacers size="twenty-four" />
            <Button 
              variant="primary"
              onClick={() => openVideo("AvtMeLwO3j0")} // Replace with your student video ID
            >
              See how it works
              <br />
              for students
            </Button>
          </div>

          <div className="features-card-2">
            <img className="img" alt="Image" src={image1} />
            <Spacers size="thirty-two" />
            <div className="div">For Teachers</div>
            <Spacers size="sixteen" />
            <div className="features-list">
              <div className="text-wrapper-2">Correct a whole class rapidly</div>
              <div className="text-wrapper-2">Convert handwritten answers to text</div>
              <div className="text-wrapper-2">Accept/reject Pulc comments and leave your own feedback </div>
            </div>
            <Spacers size="twenty-four" />
            <Button 
              variant="primary"
              onClick={() => openVideo("WN5209AyqvQ")} // Replace with your teacher video ID
            >
              See how it works
              <br />
              for teachers
            </Button>
          </div>
        </div>
      </div>

      <Spacers size="one-hundred-and-twenty-eight" />

      {/* 5) MISSION SECTION */}
      <div className="section-mission">
        <div className="intro-wrapper">
          <div className="intro-content">
            <div className="text-wrapper-3">Our Mission</div>
            <p className="text-wrapper-4">
              We want to end education inequality. <br />
              Responsible AI can help us achieve this.
            </p>
            <p className="text-wrapper-4">
              Teachers face a mountain of corrections.
              <br />
              Students struggle to understand the exam.
              <br />
              Parents feel under pressure to pay for private tutoring.
            </p>
            <div className="text-wrapper-5">This isn't education.</div>
            <div className="frame" />
            <p className="text-wrapper-6">
              Pulc.ai will level the playing field: making exam-focused
              feedback available to every student and giving teachers
              more time to teach.
            </p>
          </div>
        </div>
      </div>

      <Spacers size="one-hundred-and-twenty-eight" />
      {/* 6) TESTIMONIALS */}
      <div className="section-testimonials">
        <div className="testimonials-slider">
          <div className="testimonials-slide">
            <div className="arrow" onClick={goLeft}>
              <img className="img-2" alt="Left arrow" src={leftArrow} />
            </div>
            <div className={`slide-content ${isTransitioning ? 'transitioning' : ''}`}>
              <div 
                className="text-wrapper-7"
                key={`quote-${activeIndex}`} // Force re-render on change
                style={{opacity: isTransitioning ? 0 : 1}}
              >
                {testimonials[activeIndex].quote}
              </div>
              <Spacers size="sixteen" />
              <div 
                className="secondary-school"
                key={`person-${activeIndex}`} // Force re-render on change
                style={{opacity: isTransitioning ? 0 : 1}}
              >
                {testimonials[activeIndex].person}
              </div>
              <Spacers size="thirty-two" />
              <div className="slide-nav">
                {testimonials.map((_, idx) => (
                  <div 
                    key={idx} 
                    className={`slide-nav-dot${idx === activeIndex ? ' active' : ''}`} 
                  />
                ))}
              </div>
            </div>
            <div className="right-arrow-wrapper" onClick={goRight}>
              <img className="img-2" alt="Right arrow" src={rightArrow} />
            </div>
          </div>
        </div>
      </div>

      <Spacers size="one-hundred-and-twenty-eight" />

      {/* 7) CONTACT - Updated to replace form with signup link */}
      <div className="section-contact">
        <div className="section-contact-container">
          <div className="contact-content">
            <p className="text-wrapper-8">Pulc is trusted by over 2500 students and 1000 teachers in over 500 schools!</p>
            <a
              className="text-wrapper-9"
              href="mailto:hello@pulc.co.uk"
              rel="noopener noreferrer"
              target="_blank"
            >
              hello@pulc.co.uk
            </a>
          </div>
          <div className="contact-content-2">
            <div className="signup-cta-wrapper">
              <p className="signup-cta-text">Ready to join them?</p>
              <Link to="/register" className="signup-cta-button">
                Sign Up For Free
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Spacers size="one-hundred-and-twenty-eight" />
      
      {/* 8) ABOUT US */}
      <div className="text-wrapper-11">About us</div>
      <div className="div-wrapper">
        <div className="about-wrapper">
          <div className="about-card">
            <img className="about-avatar" alt="About avatar" src={aboutAvatar} />
            <Spacers size="thirty-two" />
            <div className="div">Cillian</div>
            <Spacers size="sixteen" />
            <div className="features-list">
              <p className="text-wrapper-2">
              I'm a university lecturer. I write quite boring papers about philosophy. I did my PhD at the University of Cambridge. When I was "young", I sold my exam notes online for £2,500 – something which my friends still mock me for relentlessly.
              </p>
            </div>
          </div>

          <div className="about-card">
            <img className="about-avatar" alt="About avatar" src={aboutAvatar2} />
            <Spacers size="thirty-two" />
            <div className="div">Charles</div>
            <Spacers size="sixteen" />
            <div className="features-list">
              <p className="text-wrapper-2">
              I studied maths at Trinity College, Dublin. I spent the last decade working in quantitative finance. I've taught maths to everyone from 5-year-olds to university students, and even taught traders to play poker.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Spacers size="one-hundred-and-twenty-eight" />

      {/* 9) DATA SECTION */}
      <div className="section-data">
        <div className="data-circle" />
        <div className="intro-wrapper">
          <div className="intro-content">
            <div className="text-wrapper-3">Your Data</div>
            <p className="with-AI-protecting">
              With AI, protecting your data is even more important than ever. We want to ensure yours stays safe.
            </p>
            
            <div className="text-wrapper-5">Pulc will</div>
            
            <div className="data-cards">
              <div className="data-card">
                <img src={icon} alt="Shield Icon" className="data-icon" />
                <div className="text-wrapper-13">Never sell your Personal Data.</div>
                
              </div>
              <div className="data-card">
                <img src={icon2} alt="Lock Icon" className="data-icon" />
                <div className="text-wrapper-13">Never share it with a Third Party for 
                Advertising.</div>
                
              </div>
              <div className="data-card">
                <img src={icon3} alt="Privacy Icon" className="data-icon" />
                <div className="text-wrapper-13">Never reveal any personal or sensitive 
                information.</div>
                
              </div>
            </div>
            
            <p className="we-do-need-to-use">
            We do need to use your essays to revise our model and make it better. This is just to make sure that we are giving a consistent grade and to make it more accurate. When that happens, your data is fully anonymised and stored securely. You always have the right to withdraw your data in full and you can do so just by emailing us at: 
            </p>
            <div className="contact-email">hello@pulc.co.uk</div>
            <img className="ebene" alt="GDPR Compliant" src={ebene2} />
          </div>
        </div>
      </div>

      {/* Updated Footer with white logo */}
      <div className="section-footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={logoWhite} alt="Pulc Logo" className="logo-white" />
            </div>
            <div className="footer-links">
              <div className="pulc-ai">PULC.AI</div>
              <Link to="/login">Login</Link>
              <Link to="/register">Sign Up</Link>
              <Link to="/uk/about">About Us</Link>
              <Link to="/uk/faq">FAQ</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/uk-tandcs">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 